import React from "react";
import { motion } from "framer-motion";
import "./AboutSection.css";
import HeroSection from "../assets/image/imageAbout.avif"

function AboutSection() {
  return (
    <motion.div
      className="about"
      id="nosotros"
      initial={{ opacity: 0, x: -100 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <img src={HeroSection} className="hero-section" alt="hero-section"></img>
      <div className="content-about-text">
        <h2 className="section-title">¿Quiénes Somos?</h2>
        <p className="section-text">
          En <strong>Conexs</strong>, conectamos empresas con una red de conductores <br></br>
          confiables para traslados y servicios courier. Nuestra plataforma <br></br>
          combina tecnología avanzada y confiabilidad para brindar soluciones <br></br>
          personalizadas y eficientes.
        </p>
      </div>
    </motion.div>
  );
}

export default AboutSection;
